import React from 'react';
import {
  CondensedLabel,
  CondensedMedium,
  Flashy,
  Gutter,
  Icon,
  Layout,
} from '@axiom/ui';

interface TalentProfileDetailCompensationDataRowProps {
  label: string;
  value: string | number | null;
  showWarning?: boolean;
}

export const TalentProfileDetailCompensationDataRow: React.FC<
  TalentProfileDetailCompensationDataRowProps
> = ({ label, value, showWarning = false }) => {
  const metricName = label.replaceAll(' ', '_');

  return (
    <Layout name={metricName}>
      <CondensedLabel>{label}:</CondensedLabel>
      <Gutter left="4px" />
      <CondensedMedium name={`${metricName}_value`}>
        {value || '--'}
      </CondensedMedium>
      {showWarning ? (
        <Gutter left="4px">
          <Flashy color="iconSecondary" name={`${metricName}_warning`}>
            <Icon name="alert-filled" />
          </Flashy>
        </Gutter>
      ) : null}
    </Layout>
  );
};
